let lockCount = 0

function acquire() {
  lockCount += 1
  if (lockCount === 1) {
    document.body.style.overflow = 'hidden'
    document.documentElement.style.overflow = 'hidden'
  }
}

function release() {
  lockCount = Math.max(0, lockCount - 1)
  if (lockCount === 0) {
    document.body.style.overflow = ''
    document.documentElement.style.overflow = ''
  }
}

// Overlays must not clobber each other's lock (e.g. MarketingPopup closing while
// QuestionModal is still open), so each holder gets its own idempotent handle
// and the page unlocks only when every holder has released.
export function createScrollLock() {
  let held = false
  return {
    lock() {
      if (held) return
      held = true
      acquire()
    },
    unlock() {
      if (!held) return
      held = false
      release()
    }
  }
}
